import React from 'react';
import { Outlet } from 'react-router';
import { Watermark } from '@link/share/components';

import Header from '@link/shinkansen/layouts/Header';
import { isProd } from '@link/shinkansen/utils';

import styles from './base.module.css';

const BaseLayout: React.FC = () => {
  return (
    <div className={styles.base}>
      <Header />
      <main className={styles.main}>
        <Outlet />
      </main>
      {!isProd && <Watermark />}
    </div>
  );
};

export default BaseLayout;
